/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignInvoiceValidationDataSchema = z.object({
	valid: z.boolean(),
	status: z.string(),
	message: z.string(),
	invoice: z.object({
		invoiceId: z.string(),
		status: z.string(),
		amountDue: z.number(),
		amountPaid: z.number(),
		total: z.number(),
		currency: z.string(),
		dueDate: z.iso.datetime().nullable(),
		hostedInvoiceUrl: z.string().nullable(),
		canLaunchCampaign: z.boolean(),
		isOverdue: z.boolean(),
		credited: z.boolean(),
	}).nullable(),
	payments: z.array(
		z.object({
			id: z.string(),
			currency: z.string(),
			amount: z.number(),
			status: z.string(),
			paidAt: z.iso.datetime().nullable(),
			paymentMethod: z.union([z.literal('Jobilla Wallet'), z.literal('Card'), z.literal('Bank Transfer')])
				.nullable(),
			receiptNumber: z.string().nullable(),
			metadata: z.record(z.string(), z.string()),
		}),
	),
})

export type CampaignInvoiceValidationDataSchema = z.infer<typeof campaignInvoiceValidationDataSchema>
